/* global angular */

var ngModule = angular.module('trends');

// TODO Put STATIC_URL in a config
var OVERLAY_TEMPLATES = {
    logo: '<div class="info"><div class="logo">'+ //<img src="/images/oxygen/email_alert/mintel_logo.png"></div>' +
          '<div class="spinner blue-spinner-2x"></div></div>',

    spinner: '<div class="info"><div class="spinner blue-spinner"></div></div>'
};

ngModule.directive('busy', ['$animate',
    function ($animate) {
        return {
            restrict: 'AC',
            require: 'busy',
            scope: {busy: '=', overlay: '@busyOverlay', overlayClasses: '@busyOverlayClasses'},
            controller: ['$scope', function ($scope) {
                var ctrl = this;

                ctrl.addIndicator = function (element) {
                    if (ctrl.overlay) {
                        return;
                    }

                    element.addClass('loading');

                    var classes = 'overlay ' + ($scope.overlayClasses ? $scope.overlayClasses : '');
                    ctrl.overlay = $('<div class="' + classes + '">' + overlayTemplate + '</div>');

                    $animate.enter(ctrl.overlay, element);
                };

                ctrl.removeIndicator = function (element) {
                    if (!ctrl.overlay) {
                        return;
                    }

                    element.addClass('overlay-leave');

                    $animate.leave(ctrl.overlay, function () {
                        element.removeClass('overlay-leave');
                        element.removeClass('loading');
                        ctrl.overlay = null;
                    });
                };

                ctrl.overlay = null;
                var overlayTemplate = OVERLAY_TEMPLATES[$scope.overlay || 'spinner'];
            }],
            link: function (scope, element, attrs, ctrl) {
                scope.$watch('busy', function (busy) {
                    if (busy) {
                        ctrl.addIndicator(element);
                    } else {
                        ctrl.removeIndicator(element);
                    }
                });
            }
        };
    }]);
